import React from 'react';
import MuiLink from '@mui/material/Link';
import {NavLink as RouterLink} from 'react-router-dom';
import {styled} from '@mui/material/styles';

const CustomMuiLink = styled(MuiLink)({
  textDecoration: 'none',
  color: 'inherit',
});

function NavLink(props) {
  return <CustomMuiLink {...props} component={RouterLink} />;
}

export default NavLink;
